export class FFmpegOutOfMemoryError extends Error {
  public readonly logs: string[];

  constructor(
    message = 'FFmpeg WebAssembly manque de mémoire',
    options: { cause?: unknown; logs?: string[] } = {}
  ) {
    super(message);
    this.name = 'FFmpegOutOfMemoryError';
    this.logs = options.logs ?? [];

    if (options.cause !== undefined) {
      (this as Error & { cause?: unknown }).cause = options.cause;
    }
  }
}

const OOM_PATTERNS = [
  /out of memory/i,
  /cannot allocate memory/i,
  /memory allocation failed/i,
  /failed to grow memory/i,
  /wasm memory/i,
  /cannot enlarge memory arrays/i,
  /memory access out of bounds/i,
  /sharedarraybuffer is not defined/i,
];

export function isLikelyFFmpegOutOfMemoryError(
  error: unknown,
  logs: string[] = []
): boolean {
  if (error instanceof FFmpegOutOfMemoryError) {
    return true;
  }

  const segments: string[] = [];

  if (typeof error === 'string') {
    segments.push(error);
  } else if (error instanceof Error) {
    segments.push(`${error.name}: ${error.message}`);
    if (typeof (error as any).stack === 'string') {
      segments.push((error as any).stack as string);
    }
  }

  segments.push(...logs);

  if (!segments.length) {
    return false;
  }

  const haystack = segments.join('\n');
  return OOM_PATTERNS.some(pattern => pattern.test(haystack));
}
